import logo from './logo.svg';
import './App.css';
import {Dialog} from './components/openPicture.js';
import {ImageView} from './components/image.js';
import { useState } from 'react';
import {Modes} from './modes.js';
import {ModeSelector} from './components/modeSelector.js';
import {Statistic} from './components/statistics.js';

function App() {
  const [image, setImage] = useState(null);
  const [cells, setCells] = useState(null);
  const [currentMode, setCurrentMode] = useState(Modes.NONE.color);

  const initCells = (columns, rows) => {
    const array = new Array(columns);
      for(let i = 0; i < columns; i++) {
        array[i] = new Array(rows);
        for(let y = 0; y < rows; y++) {
          array[i][y] = Modes.NONE.color;
        }
      }
      setCells(array);
  }

  const onCellClick = ({column, row}) => {    
    let newCells = [...cells];
    newCells[column][row] = currentMode;
    setCells(newCells);
  }

  const onModeSelected = (mode) => {
    setCurrentMode(mode);
  }

  return (
     <div className="App">  
      <ImageView image={image} cells={cells} onload={({columns, rows}) => initCells(columns, rows)} onCellClick={onCellClick}/>
     <div className="rightPanel">        
        <Dialog onPictureSelected={s => setImage(s)}/>      
        <ModeSelector selectedMode={currentMode} onSelected={onModeSelected}/>
        <Statistic cells={cells}/>
      </div>
    </div>
  );
}
export default App;
